import React from 'react';
import './InlineSpinner.css';

export function InlineSpinner({ size = 'small', message }) {
  return (
    <div className={`inline-spinner inline-spinner--${size}`}>
      <div className="inline-spinner-ring"></div>
      {message && <span className="inline-spinner-text">{message}</span>}
    </div>
  );
}

export default InlineSpinner;